/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unnamed-components */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SimpleMenu from 'ContentComponents/cmv2/fields/SimpleMenu';
import ToolFormControl from 'DesignComponents/tool/ToolFormControl';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import { SIMPLE_MENU } from 'ContentUtils/constants/CustomWidgetFieldTypes';
import { DEFAULT } from 'DesignData/enums/CustomWidgetFieldAttributes';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.fieldEdit.contentOptions.${key}`;

export default class _class extends Component {
  constructor(...args) {
    super(...args);

    this.onDefaultChange = menuData => {
      this.props.editField({
        [DEFAULT]: menuData
      });
    };
  }

  render() {
    const {
      field,
      readOnly
    } = this.props;

    const label = /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey(`defaultLabels.${SIMPLE_MENU}`)
    });

    return /*#__PURE__*/_jsx(ToolFormControl, {
      label: label,
      children: /*#__PURE__*/_jsx(SimpleMenu, {
        onFieldChange: this.onDefaultChange,
        value: field[DEFAULT],
        readOnly: readOnly
      })
    });
  }

}
_class.propTypes = {
  editField: PropTypes.func.isRequired,
  field: PropTypes.instanceOf(CustomWidgetField).isRequired,
  readOnly: PropTypes.bool
};